import buildEmailHtml from "./buildEmailHtml";
import { PRESETS } from "../config/presets";
import { normalizeDesignPayload } from "../utils/designPayload";

export function newsletterPreview(newsletter, type) {
  const body = newsletter.html || newsletter.body || "<p>(No content)</p>";
  // Sent documents are the delivery snapshot; do not wrap or append another footer.
  if (type === "sent" || /<html[\s>]/i.test(body)) return body;
  return buildEmailHtml({
    ...normalizeDesignPayload(newsletter.design || {}, PRESETS[0]),
    bodyHtml: body,
    subject: newsletter.subject,
    preheaderText: newsletter.preheaderText,
    blockStyles: newsletter.blockStyles,
    footer: newsletter.footer,
  });
}
